export type FileType = 'device' | 'workspace';

export const validateFileName = (
  fileName: string,
  fileType: FileType = 'device'
): string | null => {
  if (fileName.includes(' ')) {
    return 'Filename cannot contain spaces. Please rename the file and try again.';
  }
  if (!fileName || fileName.length > 100) {
    return 'Filename must be between 1 and 100 characters.';
  }
  if (fileType === 'workspace') {
    if (!/^[a-z0-9._()-]*$/.test(fileName)) {
      return 'Invalid filename. Use only lowercase letters, numbers, dots, underscores, parentheses, and dashes.';
    }
  } else {
    if (!/^(\.[a-zA-Z0-9_()-]|[a-zA-Z0-9])[a-zA-Z0-9._()-]*$/.test(fileName)) {
      return 'Invalid filename. Use only letters, numbers, dots, underscores, parentheses, and dashes.';
    }
  }
  return null;
};

export const validateLabel = (label: string): string | null => {
  if (label.length < 5 || label.length > 100) {
    return 'Label must be between 5 and 100 characters.';
  }
  if (!/^[a-z0-9._]*$/.test(label)) {
    return 'Label should only contain lowercase letters, numbers, dots, and underscores.';
  }
  return null;
};

export const getUploadErrorMessage = (err: unknown): string => {
  if (err && typeof err === 'object') {
    const errorObj = err as Record<string, unknown>;

    const errorMessage = errorObj.message || errorObj.error || errorObj.detail;
    if (typeof errorMessage === 'string') {
      if (
        errorMessage.toLowerCase().includes('already exists') ||
        errorMessage.toLowerCase().includes('duplicate')
      ) {
        return 'A file with this name already exists.';
      }
      return errorMessage;
    }

    const status = errorObj.status || errorObj.statusCode;
    if (status === 400) {
      return 'Invalid file or filename. Please check the file and try again.';
    }
    if (status === 413) {
      return 'File is too large to upload.';
    }
  }

  if (err instanceof Error) {
    return err.message;
  }

  return 'Upload failed. Please try again.';
};

export const FILE_READ_ERROR = 'Failed to read file';
